import { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Grid, InputAdornment, TextField, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import PropTypes from 'prop-types'

import helpers from 'helpers'

const DEFAULT_DISCOUNT_PERCENTAGE = 0

const PlatformDiscountFields = ({
  platformServicePrice,
  contractPrice,
  show,
}) => {
  const { control, errors, setValue, watch } = useFormContext()

  const currentPrice = parseFloat(platformServicePrice) || 0
  const discount = watch('discount')

  const [percentage, setPercentage] = useState(
    DEFAULT_DISCOUNT_PERCENTAGE.toFixed(2),
  )

  useEffect(() => {
    if (!currentPrice) return

    if (!discount) {
      const newPrice = currentPrice * (1 - DEFAULT_DISCOUNT_PERCENTAGE / 100)

      setPercentage(DEFAULT_DISCOUNT_PERCENTAGE.toFixed(2))
      if (!show) {
        setValue(
          'discount',
          helpers.formatters.currencyInput(newPrice.toFixed(2)),
        )
      }
      return
    }

    const discountValue = helpers.formatters.currencyOutput(discount)
    const percentageValue = Math.max(
      (1 - discountValue / currentPrice) * 100,
      0,
    )

    setPercentage(percentageValue.toFixed(2))
    // eslint-disable-next-line
  }, [currentPrice])

  const handleChangePercentage = (event) => {
    const maskedPercentage = helpers.formatters.percentage(event.target.value)
    const percentageValue = parseFloat(maskedPercentage) || 0
    const newPrice = currentPrice * (1 - percentageValue / 100)

    setPercentage(maskedPercentage)
    setValue('discount', helpers.formatters.currencyInput(newPrice.toFixed(2)))
  }

  const handleChangePrice = ([event]) => {
    const maskedPrice = helpers.formatters.currencyInput(event.target.value)
    const priceValue = helpers.formatters.currencyOutput(maskedPrice)
    const percentageValue =
      currentPrice > 0 ? Math.max((1 - priceValue / currentPrice) * 100, 0) : 0

    setPercentage(percentageValue.toFixed(2))

    return maskedPrice
  }

  const contractTotal = parseFloat(contractPrice) || 0
  const discountValue = discount
    ? helpers.formatters.currencyOutput(discount)
    : currentPrice
  const finalContractPrice = contractTotal - currentPrice + discountValue

  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity="info">
            O desconto será aplicado somente no serviço Plataforma, não no valor
            total do contrato.
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2">
            Valor total dos serviços ativos: R${' '}
            {helpers.formatters.currencyInput(contractPrice)}
          </Typography>
          <Typography variant="body2">
            Valor do serviço Plataforma: R${' '}
            {helpers.formatters.currencyInput(platformServicePrice)}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="Percentual de desconto"
            fullWidth
            variant="outlined"
            value={percentage}
            onChange={handleChangePercentage}
            disabled={show}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Controller
            as={
              <TextField
                label="Valor final da mensalidade"
                fullWidth
                variant="outlined"
                error={!!errors?.discount}
                helperText={errors?.discount?.message}
                disabled={show}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">R$</InputAdornment>
                  ),
                }}
              />
            }
            name="discount"
            control={control}
            onChange={handleChangePrice}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            <strong>
              Nova mensalidade do contrato: R${' '}
              {helpers.formatters.currencyInput(finalContractPrice.toFixed(2))}
            </strong>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

PlatformDiscountFields.propTypes = {
  platformServicePrice: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  contractPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  show: PropTypes.bool,
}

export default PlatformDiscountFields
